export const initOnEvents = ['click', 'touchstart', 'keypress', 'keydown'];

export const getAudioContext = () => {
  let audioCtx;
  try {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  } catch {
    // AudioContext is not available.
  }
  return audioCtx;
};

export const getAlertAudio = async (baseUrl = '', requestContext) => {
  const audioCtx = getAudioContext();
  const playSound = audioBuffer => {
    window.playAudioAlert = () => {
      if (audioCtx) {
        const source = audioCtx.createBufferSource();
        source.buffer = audioBuffer;
        source.connect(audioCtx.destination);
        source.loop = false;
        source.start();
      }
    };
  };

  if (audioCtx) {
    const { type = 'dashboard', alertTone = 'assobio' } = requestContext || {};
    const resourceUrl = `${baseUrl}/audio/${type}/${alertTone}.mp3`;
    const audioRequest = new Request(resourceUrl);

    fetch(audioRequest)
      .then(response => response.arrayBuffer())
      .then(buffer => {
        audioCtx.decodeAudioData(buffer).then(playSound);
        return new Promise(res => res());
      })
      .catch(() => {
        // error
      });
  }
};

export const getAlertCallAudio = async (baseUrl = '', requestContext) => {
  const audioCtx = getAudioContext();
  let currentCallAudioSource = null;

  const playSound = audioBuffer => {
    window.playCallAudioAlert = () => {
      if (audioCtx) {
        const source = audioCtx.createBufferSource();
        source.buffer = audioBuffer;
        source.connect(audioCtx.destination);
        source.loop = false;
        source.start();
      }
    };

    window.startLoopingCallAudioAlert = () => {
      if (audioCtx && !currentCallAudioSource) {
        currentCallAudioSource = audioCtx.createBufferSource();
        currentCallAudioSource.buffer = audioBuffer;
        currentCallAudioSource.connect(audioCtx.destination);
        currentCallAudioSource.loop = true;
        currentCallAudioSource.start();
      }
    };

    window.stopLoopingCallAudioAlert = () => {
      if (currentCallAudioSource) {
        currentCallAudioSource.stop();
        currentCallAudioSource = null;
      }
    };
  };

  if (audioCtx) {
    const { type = 'dashboard', alertTone = 'calling' } = requestContext || {};
    const resourceUrl = `${baseUrl}/audio/${type}/${alertTone}.m4a`;
    const audioRequest = new Request(resourceUrl);

    fetch(audioRequest)
      .then(response => response.arrayBuffer())
      .then(buffer => {
        audioCtx.decodeAudioData(buffer).then(playSound);
        return new Promise(res => res());
      })
      .catch(() => {
        // error
      });
  }
};
